import { render } from "./SingleQuote.vue?vue&type=template&id=f29c803a&lang=true"
import script from "./SingleQuote.vue?vue&type=script&lang=js"
export * from "./SingleQuote.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__